import { State, Card, Button } from '@seiue/ui'
import { downloadFile } from '@seiue/util'
import { FC, useState } from 'react'
import { useHistory } from 'react-router-dom'
import styled from 'styled-components'

import { GrowpIcon } from 'packages/components/GrowpIcon'
import {
  TaskCompletedDetail,
  Outline as OriOutline,
  CourseOutlineTaskTypeEnum,
} from 'packages/sdks-next/growp'

import { TaskLayout } from '@/components/TaskLayout'
import { activityIdStorage, store } from '@/store'

import { CourseContext } from '../context'
import { TreeOutline } from '../types'
import { formatOutlines } from '../utils'

import { LeftCard } from './Layout'
import { LeftContent } from './LeftContent'
import { Outline } from './Outline'

export type CourseContentProps = {
  taskId: number
  isPreview: boolean
  name: string
  completedDetails?: TaskCompletedDetail[]
  onPreviewClose?: () => void
  outlines: OriOutline[]
}

/**
 * 课程内容
 *
 * @param param0 - 参数
 * @param param0.taskId - 任务id
 * @param param0.isPreview - 是否预览
 * @param param0.completedDetails - 完成详情
 * @param param0.name - 任务名称
 * @param param0.onPreviewClose - 预览关闭回调
 * @param param0.outlines - 课程大纲
 * @returns 课程内容
 */
export const CourseContent: FC<CourseContentProps> = ({
  taskId,
  isPreview,
  completedDetails = [],
  name,
  onPreviewClose,
  outlines,
}) => {
  const history = useHistory()
  const [currentOutline, setCurrentOutline] = useState<TreeOutline>()
  const activityId = store.get(activityIdStorage)

  return (
    <CourseContext.Provider
      value={{
        currentOutline,
        setCurrentOutline,
        taskId,
        activityId: activityId || 0,
        isPreview,
        completedDetails,
      }}
    >
      <TaskLayout
        title={name}
        onClose={() => {
          const ele = document.getElementById('test-paper-save')
          if (
            currentOutline?.type &&
            currentOutline?.type === CourseOutlineTaskTypeEnum.Exercise &&
            ele
          ) {
            ele.click()
          }
          onPreviewClose ? onPreviewClose() : history.push('/')
        }}
        isPreview={isPreview}
      >
        <Content>
          <div>
            {currentOutline ? (
              <LeftCard
                title={
                  currentOutline.type === CourseOutlineTaskTypeEnum.Video
                    ? null
                    : currentOutline?.name
                }
                headerStyle={{
                  height: 56,
                  paddingLeft: 24,
                  fontSize: 16,
                  fontWeight: 500,
                  color: '#152529',
                }}
                className="user_course_left_card"
                style={{ borderRadius: 8, minWidth: 792, marginBottom: '20px' }}
                contentStyle={{
                  padding:
                    currentOutline.type === CourseOutlineTaskTypeEnum.Video
                      ? 0
                      : undefined,
                  overflow: 'auto',
                }}
                headerRight={
                  currentOutline?.type &&
                  currentOutline?.type === CourseOutlineTaskTypeEnum.Pdf &&
                  currentOutline.allowAttachmentDown ? (
                    <Button
                      style={{ marginRight: 0, width: 82 }}
                      onClick={() => {
                        const name = currentOutline.attachments?.[0]?.name || ''
                        const url = currentOutline.attachments?.[0]?.url
                        if (url) {
                          downloadFile(name, url)
                        }
                      }}
                    >
                      <GrowpIcon
                        name="Xiazai"
                        text="下载"
                        size={14}
                        textMarginLeft={8}
                      />
                    </Button>
                  ) : null
                }
                type="divided"
              >
                <LeftContent />
              </LeftCard>
            ) : (
              <LeftCard>
                <State.Empty />
              </LeftCard>
            )}
          </div>
          <div
            style={
              {
                // position: 'absolute',
                // top: isPreview ? 124 : 84,
                // left: 'calc(50% + 246px)',
              }
            }
          >
            <StyleCard
              type="divided"
              title={<Title>课程目录</Title>}
              style={{ width: 320, borderRadius: 8 }}
              contentStyle={{
                padding: 8,
                height: isPreview
                  ? 'calc(100vh - 203px)'
                  : 'calc(100vh - 163px)',
                overflow: 'auto',
              }}
            >
              <Outline outlines={formatOutlines(outlines)} />
            </StyleCard>
          </div>
        </Content>
      </TaskLayout>
    </CourseContext.Provider>
  )
}

const StyleCard = styled(Card)`
  min-height: 50vh;

  width: 198px;
  &&& {
    .ant-tree-switcher {
      display: flex;
      align-items: center;
      justify-content: center;
      width: 12px;
    }

    .ant-tree-indent-unit {
      width: 10px;
    }

    .ant-tree-node-content-wrapper {
      padding: 0;
      border-radius: 8px;
      width: 100%;
    }

    .ant-tree-treenode {
      width: 100%;
    }

    .ant-card-body {
      max-height: 70vh;
      overflow-y: auto;
    }
    .task-layout-content {
      position: relative;
    }
  }
`

const Title = styled.div`
  height: 56px;
  padding-left: 24px;
  font-size: 16px;
  font-weight: 500;
  line-height: 56px;
  color: ${(props) => props.theme.text._1};
`

const Content = styled.div`
  width: 1130px;
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
`
